import dynamic from 'next/dynamic';

import { useAppSelector } from '@/redux';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

const BlogMenuDesktop = dynamic(() => import('@/components/blog/BlogMenuDesktop'));
BlogMenuDesktop.displayName = 'BlogMenuDesktop';
const SubMenuMobile = dynamic(() => import('@/components/layout/SubMenuMobile'));
SubMenuMobile.displayName = 'SubMenuMobile';
const SubMenuDesktop = dynamic(() => import('@/components/layout/SubMenuDesktop'));
SubMenuDesktop.displayName = 'SubMenuDesktop';
const BlogMenuModal = dynamic(() => import('@/components/layout/modals/BlogMenuModal'), { ssr: false });
BlogMenuModal.displayName = 'BlogMenuModal';
const CellarMenuModal = dynamic(() => import('@/components/layout/modals/CellarMenuModal'), { ssr: false });
CellarMenuModal.displayName = 'CellarMenuModal';

type SubMenuProps = {
  type?: string;
  rest?: {
    links: { title: string; url: string }[];
    currentPage: string;
  };
}

const componentMap = {
  cellar: () => dynamic(() => import('@/components/layout/SubMenuDesktop').then((module) => module.SubMenuDesktop)),
  blog: () => dynamic(() => import('@/components/blog/BlogMenuDesktop').then((module) => module.BlogMenuDesktop)),
};

export const SubMenu = ({ type = 'blog', rest }: SubMenuProps) => {
  const blogMenuModalVisible = useAppSelector(({ gui }) => gui.blogMenuModalVisible);
  const cellarMenuModalVisible = useAppSelector(({ gui }) => gui.cellarMenuModalVisible);
  const { isMobileOrTablet } = useScreenSizeContext();

  const Component = componentMap[type]();

  return isMobileOrTablet ? (
    <>
      <SubMenuMobile type={type} />
      {cellarMenuModalVisible && <CellarMenuModal links={rest?.links} />}
      {blogMenuModalVisible && <BlogMenuModal />}
    </>
  ) : (
    <Component {...rest} />
  );
};

export default SubMenu;
